module.exports = __webpack_public_path__ + "d8d5e023c361defeef01957c2d9f8385.svg";